const LTV_URL = '/ltv';

export function ltvStatisticApi() {
  return `${LTV_URL}/statistic`;
}

export function ltvTrendsApi() {
  return `${LTV_URL}/trends`;
}
